import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import PersonCardMultiSelect from './personCardMultiSelect';

const StyledPersonCardMultiSelect = styled(PersonCardMultiSelect)`
  margin-bottom: 20px;
`;

const PersonMultiSelectTabPanel = ({
  onRemove,
  onSelect,
  people,
  personGroup,
  selectedPeopleByGroup,
  personRenderer,
}) => {
  if (personGroup == null) {
    return null;
  }
  return (
    <StyledPersonCardMultiSelect
      onRemove={onRemove}
      onSelect={onSelect}
      people={people}
      personRenderer={personRenderer}
      selectedPeople={selectedPeopleByGroup[personGroup.id]}
    />
  );
};

PersonMultiSelectTabPanel.defaultProps = {
  onRemove: () => {},
  onSelect: () => {},
  people: [],
  personGroup: undefined,
};

PersonMultiSelectTabPanel.propTypes = {
  onRemove: PropTypes.func,
  onSelect: PropTypes.func,
  people: PropTypes.arrayOf(PropTypes.object),
  personGroup: PropTypes.object,
  selectedPeopleByGroup: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
};

export default PersonMultiSelectTabPanel;
